import { addTouchStartListener } from "./swipe-back"
addTouchStartListener()

declare global {
  interface Document {
    flutterStarted?: boolean
  }
}

function isIOS() {
  return (
    /iPhone|iPad|iPod/.test(navigator.platform) ||
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  )
}

document.flutterStarted = false

addEventListener("unhandledrejection", (event) => {
  if (event.reason instanceof EvalError) {
    if (isIOS() && !document.flutterStarted) {
      document.write(`
        <head>
          <style>
            @font-face {
              font-family: 'ABC Repro Variable';
              src: url('/assets/packages/common/fonts/ABCRepro-Regular.otf') format('opentype');
              font-weight: normal;
              font-style: normal;
            }
            * {
              box-sizing: border-box;
            }
            body {
              width: 100%;
              height: 100dvh;
              display: flex; 
              flex-direction: column; 
              justify-content: center; 
              align-items: center;
              padding: 24px;
            }
            .title {
              max-width: 315px; 
              text-align: center; 
              font-family: 'ABC Repro Variable'; 
              font-size: 23px; 
              font-style: normal; 
              font-weight: 400; 
              line-height: 140%; 
              letter-spacing: -0.69px; 
              margin-top: 16px; 
              margin-bottom: 4px;
            }
            .description {
              color: rgba(0, 0, 0, 0.55);
              max-width: 315px; 
              text-align: center; 
              font-family: 'ABC Repro Variable'; 
              font-size: 16px; 
              font-style: normal; 
              font-weight: 400; 
              line-height: 150%; 
              letter-spacing: -0.32px;
            }
          </style>
        </head>
        <body>
          <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.4922 16.6133V25.2124M24.4998 31.4836V31.3882M42.5 24C42.5 14.0582 34.4418 6 24.5 6C14.5582 6 6.5 14.0582 6.5 24C6.5 33.9398 14.5582 42 24.5 42C34.4418 42 42.5 33.9398 42.5 24Z" stroke="#EB024C" stroke-width="3" stroke-linecap="square" stroke-linejoin="round"/>
          </svg>

          <h1 class="title">Sorry, your iOS version isn’t supported</h1>

          <p class="description">This web app doesn’t load on iOS 15 or lower. Please update your device or try accessing it on a different browser.</p>
        </body>
      `)
    }
  }
})
